import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CrudService {

    endpoint: any;

    constructor(
        public httpClient: HttpClient,
        @Inject(String) private resourceLink: string
    ) {
        this.endpoint = environment.endpoint + resourceLink;
    }

    get(params?: any): Observable<any> {
        const t = this;
        return this.httpClient
            .get(t.endpoint, {headers: {}, params})
            .pipe(
                map((res: any) => res || []));
    }

    delete(id: any): Observable<boolean> {
        const t = this;
        return this.httpClient
            .delete(t.endpoint + '/' + id, {headers: {}})
            .pipe(
                map((res: any) => res || []));
    }

    createOrUpdate(data: any): Observable<boolean> {
        const t = this;
        if (!data.id) {
            return this.httpClient
                .post(t.endpoint, data, {headers: {}})
                .pipe(
                    map((res: any) => res || []));
        } else {
            return this.httpClient
                .put(t.endpoint + '/' + data.id, data, {headers: {}})
                .pipe(
                    map((res: any) => res || []));
        }
    }


    find(id: any): Observable<boolean> {
        const t = this;

        return this.httpClient
            .get(t.endpoint + '/' + id, {headers: {}})
            .pipe(
                map((res: any) => res || []));
    }
}
